var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "settings", staticClass: "settings row" }, [
    _c(
      "div",
      { staticClass: "settings-header col-12" },
      [
        _vm._v("\n        " + _vm._s(_vm.title) + "\n        \n        "),
        _vm.tooltip
          ? _c("tooltip-circle", { attrs: { html: true, text: _vm.tooltip } })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "settings-body col-12" }, [_vm._t("body")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }